<div class="flex h-14 justify-start p-3 md:hidden">
  <app-button
    theme="transparent"
    styleClass="h-8! text-text-default!"
    [icon]="true"
    (click)="toPrev.emit()">
    <ic-arrow-left-outline class="block h-5 w-5" />
  </app-button>
</div>
<div class="mx-auto max-w-sm space-y-6 p-6 md:py-40">
  <div class="space-y-2">
    <p class="text-text-default text-xl font-bold">Lupa Pin</p>
    <p class="text-text-default text-sm">
      Masukan E-mail yang terdaftar, Abang akan mengirim kode OTP untuk memverifikasi akunmu
    </p>
  </div>
  <form
    class="space-y-3"
    [formGroup]="form">
    <div class="space-y-0.5">
      <app-input-text
        class="block"
        formControlName="email"
        styleClass="h-10!"
        placeholder="E-mail"
        (ngModelChange)="formService.resetError(formError, 'email')">
        <div
          template="prefix"
          class="flex aspect-square h-full items-center justify-center">
          <ic-email-outline class="text-icon-subtle block h-5 w-5" />
        </div>
      </app-input-text>
      @if (formError.email.msg) {
        <p class="text-text-error text-xs">{{ formError.email.msg }}</p>
      }
    </div>
    <app-button
      class="block"
      styleClass="h-10!"
      [disabled]="formSubmitting()"
      (click)="_onSubmit()">
      Lanjutkan
    </app-button>
  </form>
</div>
